'use strict';

var ModuloInitializerMixin = require("moduleFold/modulobase/scripts/mixins/ModuleInitializerMixin");


/**
 * Controller relativo al template della route /mbdistinte
 *
 * @class
 * @param {type} $http
 * @param {type} $q
 * @param {type} $timeout
 * @param {type} $stateParams
 * @param {DataSourceFactory} DSF
 * @param {GridFactory} GF
 * @param {type} ToolbarS
 * @param {type} idstato
 * @param {type} $scope
 * @param {type} UsermanagerSrv
 */                            
function UsermanagerCtrl($http, $q, $timeout, $state, $stateParams, DSF, GF, ToolbarS, idstato, $scope, UsermanagerSrv){
    var self = this;
    self.ts = ToolbarS;
    self.ts.idAttuale = idstato;
    self.dsf = DSF;
    self.gf = GF;
    self.$http = $http;
    self.$timeout = $timeout;
    self.$q = $q;
    self.fa = UsermanagerSrv;
    self.$state = $state;

    //attualmente strentity codapp codmodulo selezione mode
    self.parametri = $stateParams;
    self.parametri.strentity = 'utenti';
    self.parametri.codapp = "";
    self.parametri.codmodulo = "BWCUtenti";

    angular.extend(this, ModuloInitializerMixin.prototype);

    //si occupa di istanziare datasource, griglia, di fare la prima lettura e di selezionare l'entity e attivare la modalità specificata
    self.inizializza();
    
}

module.exports = UsermanagerCtrl;
